import { isInApp } from '@umu/umu-ua';
import { sendMsgToApp } from './sengMsgToApp';
import { SendMsgType, TOOGLE_TYPE } from '@umu/umu-types';

// toggle navbar
// https://wiki.umu.work/pages/viewpage.action?pageId=13369646
export function toggleAppNavBar(toogleType: TOOGLE_TYPE) {
    if (!isInApp()) {
        return;
    }
    sendMsgToApp(SendMsgType.toggleAppBar, {
        action: toogleType,
    });

    console.log('toggleAppNavBar: ', toogleType);
}
